import { safeFilter, safeMap } from "@App/utils/array";
import { GarageProperty } from "@App/apis/graphql/perimeterSearch/responses/garageProperty";

/**
 * Filters and returns eligible garage properties based on their IDs.
 *
 * This function compares the IDs of `garageProperties` with those in
 * `availableGarageProperties` and returns the matching properties.
 *
 * @param {GarageProperty[] | null} garageProperties - The list of garage properties to check against.
 * @param {GarageProperty[] | null} availableGarageProperties - The list of available garage properties to filter.
 * @returns {GarageProperty[]} - The filtered list of eligible garage properties.
 */
export const eligibleGarageProperties = (
  garageProperties: GarageProperty[] | null,
  availableGarageProperties: GarageProperty[] | null,
): GarageProperty[] => {
  // Return an empty array if no available garage properties are provided
  if (!availableGarageProperties) return [];

  // Filter available garage properties whose IDs are present in the garageProperties list
  const garagePropertyIds = new Set(safeMap(garageProperties ?? [], (gp) => gp.id));
  return safeFilter(availableGarageProperties, (property) => garagePropertyIds.has(property.id));
};
